import base from './baseApi';
const { get } = base();

export const geocoding = (searchText: any, limit: any, country: any) => {
   return get(`/common/geocoding/places`, { searchText, limit, country });
};

export const searchBoxSuggest = (searchText: any, limit: any, siteId?: string, country?: string) => {
   const params: any = { searchText, limit };
   if (siteId) {
      params.siteId = siteId;
   }
   if (country) {
      params.country = country;
   }
   return get(`/common/searchBox/suggest`, params);
};

export const searchBoxRetrieve = (mapboxId: any, siteId?: string) => {
   const params: any = {};
   if (siteId) {
      params.siteId = siteId;
   }
   return get(`/common/searchBox/retrieve/` + mapboxId, params);
};
